<template>
  <header class="header">
    <div class="header-logo">
      <button class="button-reset header-logo-image" type="button" @click="logoClick()"></button>
    </div>
    <div class="v-beta">
      <span>BETA</span>
    </div>
    <div class="header-create-item">
      <router-link :to="{ name: 'item-create' }" class="button-reset button-base header-item-create-link">
        <i class="fas fa-marker"></i>Skapa annons gratis
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderMain',
  methods: {
    logoClick () {
      if (sessionStorage.getItem('s_page')) { sessionStorage.removeItem('s_page') }
      if (sessionStorage.getItem('s_y')) { sessionStorage.removeItem('s_y') }
      if (sessionStorage.getItem('s_query')) { sessionStorage.removeItem('s_query') }

      this.$router.push('/').catch(
        // eslint-disable-next-line
        (e) => {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.header {
  background-color: map-get($colors, yellow-lightest);
  border-bottom: 1px solid map-get($colors, yellow-base);
  width: 100%;
  height: 60px;
  display: flex;
  position: relative;
}

.v-beta {
  color: map-get($colors, yellow-darkest);
  font-size: 1rem;
  position: absolute;
  top: 38px;
  left: 50px;
  pointer-events: none;
}

.header-logo {
  padding-left: 16px;
}

.header-logo-image {
  background: url('~@/assets/svg/gluo-logo-dark.svg') no-repeat left center;
  background-size: 60px;
  cursor: pointer;
  width: 60px;
  height: 100%;
  display: block;
}

.header-create-item {
  margin-left: auto;
  padding-right: 16px;
  align-self: center;
}

.header-item-create-link {
  background-color: #fff;
  border-bottom: 1px solid map-get($colors, gray-lighter);
  border-radius: 25px;
  color: map-get($colors, gray-medium);
  font-size: 1.4rem;
  padding: 12px 18px;
  display: flex;

  @include breakpoint-up($md) {
    font-size: 1.3rem;
  }
}

.header-item-create-link .fas {
  color: map-get($colors, gray-base);

  @include breakpoint-up($md) {
    margin-right: 8px;
  }
}

.header-item-create-link:hover,
.header-item-create-link:hover .fas {
  color: map-get($colors, green-dark);
}
</style>
